import { FC, ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";
import Tooltip from "react-tooltip";
import copy from "copy-to-clipboard";

import { Text } from "uikit";

import {
  Container,
  ContainerInner,
  CopyButtonContainer,
  StyledCopyIcon,
  StyledTooltipContainer,
} from "./styles";

interface Props {
  className?: string;
  children: string | ReactNode;
  copyContent: string;
  id: string;
  showCopyButton?: boolean;
}

const CopyText: FC<Props> = ({ className, children, copyContent, id, showCopyButton }) => {
  const { t } = useTranslation();
  const renderTooltip = (children: ReactNode) => {
    return (
      <StyledTooltipContainer data-for={id} data-html={false} data-tip={t("common.copied")}>
        <ContainerInner>
          {children}

          {showCopyButton && (
            <CopyButtonContainer>
              <StyledCopyIcon />
              <Text $fw="semiBold" $fs="t14" $color="gray.500_main">
                <Trans i18nKey={"buttons.copy"} />
              </Text>
            </CopyButtonContainer>
          )}
        </ContainerInner>

        <Tooltip
          id={id}
          place="top"
          type="dark"
          effect="float"
          event="click"
          afterShow={() => {
            copy(copyContent);
            setTimeout(Tooltip.hide, 2000);
          }}
        />
      </StyledTooltipContainer>
    );
  };

  return <Container className={className}>{renderTooltip(children)}</Container>;
};

export default CopyText;
